import { useParams } from 'react-router-dom';
import '../css/patientLandingPage.less';
import PatientLogin from './components/PatientLogin';
import useGetPatientData from './hooks/useGetPatientData';

const PatientLandingPage = () => {
  const { countryCode } = useParams();
  const getPatientData = useGetPatientData({ countryCode });

  return (
    <PatientLogin getPatientData={getPatientData} countryCode={countryCode} />
  );
}

export default PatientLandingPage;
